export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    more: {
      type: Boolean,
      default: false,
    },
    href: {
      type: [Object, String],
    },
    showBottom: {
      type: Boolean,
      default: true,
    },
    away: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    moreModifier() {
      return { 'insight-panel__link--more': this.more };
    },
    openModifier() {
      return { 'insight-panel--open': this.open };
    },
  },
  methods: {
    onClick() {
      if (typeof this.href === 'object') {
        this.$router.push(this.href);
      } else if (this.away) {
        window.open(this.href, '_blank');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/insight/insight-panel/insight-panel.js